/**
 * Entry point for running the application.
 * Must export an object with a start() method.
 *
 * Since this is a component, the entry point is only used for running it in isolation.
 * When consumed by a page or feature, the entry point will be defined by the consumer.
 */
import $ from 'jquery';
import '@core/style-guide/src/scss/macys-base.scss';
import Component from './src/shop-the-look-pdp';
import { Actions as ProductDetailsActions } from '@page/digital-product-ui-mcom/src/js/util/Constants';
import {Properties} from '@page/digital-product-ui-mcom/src/js/util/Properties';
import Logger from '@core/util/universal-logger';
import Model from './src/js/models/shop-the-look-pdp';
// import store from '@core/lib/store';
import Marionette from 'backbone.marionette';
import 'backbone.radio';
import '@core/vendor/radio.shim';
// import * as DigitalProduct from '@page/digital-product-ui-mcom/src/js/digital-product-details-mcom.js';
import { getProductView } from  './src/js/views/pdp-loader.js';
import ProductModel from '@page/digital-product-ui-mcom/src/js/ProductModel';

const ObjectUtil = require('@core/util/object');

const PageApp = new Marionette.Application();
PageApp.getMeta = key => ObjectUtil.getChildProperty(PageApp.meta, key) || '';

PageApp.starter = function(){
  PageApp.componentPDP = new Component('#main', {
    opt: 'val'
  });
  PageApp.componentPDP.init();
  window.shop_the_look_pdp = PageApp.componentPDP;
}

PageApp.on('start', PageApp.starter);


export default PageApp;



// WEBPACK FOOTER //
// /Users/m802941/WebstormProjects/2020/campaigns/shop-the-look-pdp/app.js